import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation, Trans } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { DropdownButton, Dropdown } from 'react-bootstrap';

const CustomersTableHeader = ({ selectedRowIds, onComplete, onDelete }) => {
  const { t } = useTranslation('commerce');
  const params = useParams();
  return (
    <Row className="flex-between-center">
      <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
        <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
          <Trans ns="commerce">Orders</Trans>
        </h5>
      </Col>
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
        {Object.keys(selectedRowIds).length > 0 ? (
          <div>
            <DropdownButton
              align="end"
              title={t('Bulk Actions')}
              size="sm"
              variant="falcon-default"
              id="dropdown-menu-align-right"
            >
              <Dropdown.Item
                onClick={() => onComplete(Object.keys(selectedRowIds))}
              >
                <Trans ns="commerce">Completed</Trans>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() => onDelete(Object.keys(selectedRowIds))}
                className="text-danger"
              >
                <Trans ns="commerce">Delete</Trans>
              </Dropdown.Item>
            </DropdownButton>
          </div>
        ) : (
          <div id="orders-actions">
            <IconButton
              className="border-300"
              iconClassName="me-1"
              variant="outline-secondary"
              size="sm"
              icon="chevron-left"
              transform="shrink-4"
              as={Link}
              to={`/${params.corp}/e-commerce/product/product-grid`}
            >
              <Trans ns="commerce">Continue Shopping</Trans>
            </IconButton>
          </div>
        )}
      </Col>
    </Row>
  );
};

CustomersTableHeader.propTypes = {
  selectedRowIds: PropTypes.object,
  onComplete: PropTypes.func,
  onDelete: PropTypes.func
};

export default CustomersTableHeader;
